// import React, { Component } from 'react';
// import Slider from 'react-slick';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// const CrackedCodeSettings = {
//   dots: true,
//   arrows: true,
//   infinite: true,
//   speed: 500,
//   slidesToShow: 2.5,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 5000,
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 2,
//       },
//     },
//     {
//       breakpoint: 991,
//       settings: {
//         slidesToShow: 1,
//       },
//     },
//     {
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 1,
//         dots: true,
//         arrows: true,
//       },
//     },
//     {
//       breakpoint: 575,
//       settings: {
//         slidesToShow: 1,
//         dots: true,
//         arrows: true,
//       },
//     },
//   ],
// };

// class CrackedCodeSlider extends Component {
//   render() {
//     const sliderItems = [
//       { id: 1, name: "— Nancy S.", location: "Sydney, Australia", description: "I had taken the PTE exam twice before and always missed by a few marks. After joining LA, I finally understood what I was doing wrong. The feedback was so detailed, and the templates just worked! I got 90 on my next attempt." },
//       { id: 2, name: "— Ravneet T.", location: "Melbourne, Australia", description: "I tried multiple apps and free resources, but nothing came close to the accuracy of LA’s platform. Their scored mock test was exactly like the real exam. I followed their strategies and got my PR points sorted!" },
//       { id: 3, name: "— Sujal T.", location: "Brisbane, Australia", description: "No one else offers the kind of 1-on-1 feedback Language Academy does. I cracked NAATI CCL in one go after struggling for months." },
//     ];

//     return (
//       <div className="cracked-section slider-dot-arrow">
//         <div className="container">
//           <h2
//             className="primary-heading text-center"
//             dangerouslySetInnerHTML={{ __html: this.props.title }}
//           />
//           <h3
//             className="sub-title text-center fw-600 my-4"
//              dangerouslySetInnerHTML={{ __html: this.props.subtitle }}
//           />
//         </div>
//         <div className="slider-bleed-wrapper">
//           <Slider {...CrackedCodeSettings} className="home-cards-slider">
//             {sliderItems.map(item => (
//               <div key={item.id}>
//                 <div className="crack-card">
//                   <div className="crack-img-wrapper">
//                     {/* Optional image or icon */}
//                   </div>
//                   <div className="crack-content">
//                     <div className="user-info">
//                       <div className="user-img">
//                         <img src="/images/web-new-images/crack-user.png" alt={item.name} />
//                       </div>
//                       <div className="user-content">
//                         <h3 className="user-name">{item.name}</h3>
//                         <h3 className="user-location">{item.location}</h3>
//                       </div>
//                     </div>
//                     <div className="user-discription">
//                       {item.description}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </Slider>
//         </div>
//       </div>
//     );
//   }
// }

// export default CrackedCodeSlider;


import React from 'react';
import Slider from 'react-slick';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

const CrackedCodeSettings = {
  dots: true,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 2.5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: true,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: true,
      },
    },
  ],
};

const CrackedCodeSlider = (props) => {
  const sliderItems = [
    { id: 1, name: "— Nancy S.", location: "Sydney, Australia", description: "I had taken the PTE exam twice before and always missed by a few marks. After joining LA, I finally understood what I was doing wrong. The feedback was so detailed, and the templates just worked! I got 90 on my next attempt." },
    { id: 2, name: "— Ravneet T.", location: "Melbourne, Australia", description: "I tried multiple apps and free resources, but nothing came close to the accuracy of LA's platform. Their scored mock test was exactly like the real exam. I followed their strategies and got my PR points sorted!" },
    { id: 3, name: "— Sujal T.", location: "Brisbane, Australia", description: "No one else offers the kind of 1-on-1 feedback Language Academy does. I cracked NAATI CCL in one go after struggling for months." },
  ];

  return (
    <div className="cracked-section slider-dot-arrow">
      <div className="container">
        <h2
          className="primary-heading text-center"
          dangerouslySetInnerHTML={{ __html: props.title }}
        />
        <h3
          className="sub-title text-center fw-600 my-4"
          dangerouslySetInnerHTML={{ __html: props.subtitle }}
        />
      </div>
      <div className="slider-bleed-wrapper">
        <Slider {...CrackedCodeSettings} className="home-cards-slider">
          {sliderItems.map(item => (
            <div key={item.id}>
              <div className="crack-card">
                <div className="crack-img-wrapper">
                  {/* Optional image or icon */}
                </div>
                <div className="crack-content">
                  <div className="user-info">
                    <div className="user-img">
                      <img src="/images/web-new-images/crack-user.png" alt={item.name} />
                    </div>
                    <div className="user-content">
                      <h3 className="user-name">{item.name}</h3>
                      <h3 className="user-location">{item.location}</h3>
                    </div>
                  </div>
                  <div className="user-discription">
                    {item.description}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default CrackedCodeSlider;